// Internal shared value constants used across domain files. Not part of the public API.
// Split from constants.js — edit here, not the barrel.
import { LANG } from '../lang'

const { ZH_TW, ...rest } = LANG
export { LANG, ZH_TW, rest }
export { APP_VERSION_RESTAURANT } from '../../actions/types'

export const ADMIN_DEVICE_URL = 'shop/admin_device'
export const ITEM_ALL = 'ITEM_ALL'
export const ITEM_4BY3 = 'ITEM_4BY3'
export const ITEM_ICON = 'ITEM_ICON'
export const ITEM_DETAIL = 'ITEM_DETAIL'
export const CASH_COUPON_BRAND_IMAGE = 'CASH_COUPON_BRAND_IMAGE'
export const CASH_COUPON_LEFT_IMAGE = 'CASH_COUPON_LEFT_IMAGE'
export const CASH_COUPON_DETAIL = 'CASH_COUPON_DETAIL'
export const CASH_COUPON_PURCHASED_DETAIL = 'CASH_COUPON_PURCHASED_DETAIL'
export const GLOBAL = 'GLOBAL'
export const MOBILE = 'MOBILE'
export const WECHAT_MP = 'WECHAT_MP'
export const PAPER_TO_MOBILE = 'PAPER_TO_MOBILE'
export const PAPER_TO_WECHAT_MP = 'PAPER_TO_WECHAT_MP'
export const SPRING_BOARD = 'SPRING_BOARD'
export const WEB = 'WEB'
export const PACKAGE_ITEM = 'PACKAGE_ITEM'
export const PACKAGE_SUB_ITEM = 'PACKAGE_SUB_ITEM'
export const PREORDER_ITEM = 'PREORDER_ITEM'
export const ECOUPON_ITEM = 'ECOUPON_ITEM'
export const VALUE_UP_ECOUPON_ITEM = 'VALUE_UP_ECOUPON_ITEM'
export const FREE_ECOUPON_ITEM = 'FREE_ECOUPON_ITEM'
export const CASH_ECOUPON_ITEM = 'CASH_ECOUPON_ITEM'
export const CATEGORY_ALL = 'CATEGORY_ALL'
export const CATEGORY_ICON = 'CATEGORY_ICON'
export const CATEGORY_4BY3 = 'CATEGORY_4BY3'
export const CATEGORY_DETAIL = 'CATEGORY_DETAIL'
export const FIXED_START_END = 'FIXED_START_END'
export const FLEXIBLE_DAYS = 'FLEXIBLE_DAYS'
export const PREORDER = 'PREORDER'
export const TEXT = 'TEXT'
export const SELECT = 'SELECT'
export const AUTO_GENERATE = 'AUTO_GENERATE'
export const AUTO_GENERATE_MEZZOFY = 'AUTO_GENERATE_MEZZOFY'
export const CUSTOMIZE = 'CUSTOMIZE'
export const CUSTOMIZE_TGR = 'CUSTOMIZE_TGR'
export const CUSTOMIZE_MASS_CODE = 'CUSTOMIZE_MASS_CODE'
export const WEB_CAMPAIGN_TITLE = 'WEB_CAMPAIGN_TITLE'
export const WEB_CAMPAIGN_DESCRIPTION = 'WEB_CAMPAIGN_DESCRIPTION'
export const GENERAL = 'GENERAL'
export const DRAFT_VER = Number(process.env.REACT_APP_PRODUCT_DRAFT_VER)
export const CATEGORY = {
    categoryCode: '',
    codeDescription: '',
    channel: '',
    channelSave: '',
    tcName: '',
    enName: '',
    scName: '',
    scNameDisable: true,
    tcDescription: '',
    enDescription: '',
    scDescription: '',
    scDescriptionDisable: true,
    refCategoryCode: '',
    refCategoryTcName: '',
    refCategoryId: '',
    startDisplayTimestamp: 0,
    endDisplayTimestamp: 0,
    displaySequence: 0,
    imageList: [],
}
export const PRODUCT = {
    productCode: 'Product_0',
    type: '',
    channel: '',
    displaySequence: 0,
    redeemGroupCode: '',
    settlementConfigId: '',
    systemGroupId: '',
    systemGroupName: '',
    brandCode: '',
    brandName: '',
    brandTcName: '',
    tcName: '',
    enName: '',
    scName: '',
    scNameDisable: true,
    tcDescription: '',
    enDescription: '',
    scDescription: '',
    scDescriptionDisable: true,
    tcTac: '',
    enTac: '',
    scTac: '',
    scTacDisable: true,
    tcRedeemDescription: '',
    enRedeemDescription: '',
    scRedeemDescription: '',
    scRedeemDescriptionDisable: true,
    tcDiscountDescription: '',
    enDiscountDescription: '',
    scDiscountDescription: '',
    scDiscountDescriptionDisable: true,
    tcTag: '',
    enTag: '',
    scTag: '',
    originalPrice: -1,
    sellingPrice: -1,
    startDisplayTimestamp: null,
    endDisplayTimestamp: null,
    personLimit: 50,
    quantityPerOrder: 50,
    dailyQuota: -1,
    bufferRedeemDay: 0,
    searchable: '',
    selfRedeem: '',
    selfRefund: false,
    shareable: '',
    packageCashCoupon: false,
    requireFillInContactPerson: '',
    requireFillInMobileNumber: '',
    requireFillInEmail: '',
    subProductMapList: [],
    imageList: [],
    lotInventoryList: [],
    blackoutPeriodList: [],
    attributeList: [],
}

// Shared dropdown choices — boolean yes/no pair (was duplicated 87x inside CHOICES).
export const BOOLEAN_CHOICES = [
    { value: true, name: 'true' },
    { value: false, name: 'false' },
]
